'use strict';

module.exports = thematicBreak;

function thematicBreak(h, node) {
  return h(node, 'thematicBreak');
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/thematic-break.js
// module id = 1030
// module chunks = 0